// Autogrow textarea as text changes
//
// Usage <%= text_area_tag :name, content, data: { controller: 'autogrow-textarea', target: 'autogrow.textarea', action: 'input->autogrow#resize' } %>

import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["textarea"]

  connect() {
    this.setStyles({
      resize: 'none',
      overflow: 'hidden'
    })
    this.resize()
  }

  resize(){
    this.setStyles({height: '5px'}) // Force textarea to shrink back to its minimum height
    this.setStyles({height: this.scrollHeight})
  }

  get scrollHeight() {
    return this.textareaTarget.scrollHeight + 'px'
  }

  setStyles(styles) {
    for (var property in styles) {
      this.textareaTarget.style[property] = styles[property]
    }
  }
}
